<template>
  <div>
    <v-menu v-model="menuOpen" offset-y transition="scale-transition" left content-class="notifications-menu">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-badge :content="unreadCount" color="red" overlap v-if="unreadCount > 0">
            <v-icon>mdi-bell</v-icon>
          </v-badge>
          <v-icon v-else>mdi-bell</v-icon>
        </v-btn>
      </template>

      <v-card width="600" class="pa-2">
        <v-list dense>
          <v-subheader class="d-flex justify-space-between align-center">
            <span>Notifiche recenti</span>
            <v-btn small text @click="markAllRead" v-if="unreadCount > 0">Segna tutte come lette</v-btn>
          </v-subheader>

          <div class="notification-card">
            <v-slide-y-transition group mode="out-in">
              <template v-for="(push, index) in pushNotifications">
                <v-list-item
                    :key="push._id"
                    @click="openPush(push)"
                    class="notification-item"
                    :class="{ 'unread': !push.read }"
                >
                  <v-list-item-avatar>
                    <v-icon :color="getIconColor(push.type)" >
                      {{ getIcon(push.type) }}
                    </v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <div class="d-flex justify-space-between align-center mb-1">
                      <div class="font-weight-medium text-wrap text-body-2 text--primary">
                        {{ push.title }}
                      </div>
                      <v-icon small color="primary" v-if="!push.read">mdi-circle</v-icon>
                    </div>

                    <div class="text-body-2 text-wrap text--primary">
                      {{ push.description }}
                    </div>

                    <div class="text-caption mt-1 grey--text">
                      {{ formatDate(push.created_at) }}
                    </div>
                  </v-list-item-content>
                </v-list-item>

                <!-- Divider tra le notifiche -->
                <v-divider
                    v-if="index < pushNotifications.length - 1"
                    :key="`divider-${push._id}`"
                    class="my-1"
                />
              </template>
            </v-slide-y-transition>
            <v-list-item v-if="pushNotifications.length > 0" @click="openModalAllNotifications">
              <v-list-item-content class="text-center">
                <v-list-item-title class="blue--text text--darken-2">Mostra tutte</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>


          <v-list-item v-if="pushNotifications.length === 0">
            <v-list-item-content>
              <v-list-item-title>Nessuna notifica</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
    <v-dialog v-model="dialog" max-width="600" persistent scrollable>
      <v-card>
        <v-card-title class="justify-space-between">
          <span class="text-h6">Tutte le notifiche</span>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="notification-scroll" @scroll.passive="handleScroll">
          <v-list dense>
            <template v-for="(n, index) in allNotifications">
              <v-list-item @click="openPush(n,true)" :class="{ 'unread': !n.read }" class="notification-item">
                <v-list-item-avatar>
                  <v-icon :color="getIconColor(n.type)">{{ getIcon(n.type) }}</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium text-wrap">
                    {{ n.title }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-wrap">
                    {{ n.description }}
                  </v-list-item-subtitle>
                  <div class="text-caption mt-1 grey--text">{{ formatDate(n.created_at) }}</div>
                </v-list-item-content>
              </v-list-item>
              <v-divider v-if="index < allNotifications.length - 1"></v-divider>
            </template>

            <v-list-item v-if="!allNotifications.length && !loadingAll">
              <v-list-item-content><v-list-item-title>Nessuna notifica trovata</v-list-item-title></v-list-item-content>
            </v-list-item>

            <v-list-item v-if="loadingAll">
              <v-list-item-content class="text-center"><v-progress-circular indeterminate color="primary" /></v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'PushNotificationBell',
  data() {
    return {
      pushNotifications: [],
      unreadCount: 0,
      allNotifications: [],
      dialog: false,
      menuOpen: false,
      refreshInterval: null,
      page: 1,
      limit: 20,
      total: 0,
      loadingAll: false
    }
  },
  watch: {
    '$route.fullPath': 'fetchPushNotifications',
    menuOpen(val) {
      if (val && this.unreadCount > 0) this.markAllRead();
    }
  },
  mounted() {
    let highestId = setInterval(() => {}, 9999);
    for (let i = 0; i <= highestId; i++) {
      clearInterval(i);
    }

    this.fetchPushNotifications();

    this.refreshInterval = setInterval(() => {
      this.fetchPushNotifications();
    }, 15000);

    this.$root.$on('refreshNotifications', this.fetchPushNotifications);

  },
  beforeDestroy() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
    }
    this.$root.$off('refreshNotifications', this.fetchPushNotifications);
  },
  methods: {
    ...mapActions({
      getNotifications: 'pushNotifications/index',
      getAllNotifications: 'pushNotifications/paginated',
      readNotification: 'pushNotifications/read',
      markAllAsRead: 'pushNotifications/markAllAsRead',
    }),
    async fetchPushNotifications() {
      const result = await this.getNotifications()
      this.pushNotifications = result.pushNotifications || []
      this.unreadCount = result.unreadCount || 0
    },
    async openPush(push, fromAll = false) {
      if (!push.read) {
        await this.readNotification({ id: push._id });
        push.read = true;
      }

      if (push.url) {
        if (fromAll) {
          window.open('/#'+push.url, '_blank');
        } else {
          if (this.$route.path !== push.url) {
            await this.$router.push(push.url);
          } else {
            window.scrollTo(0, 0);
            this.$emit('refresh');
          }
        }
      }
    },
    async markAllRead() {
      const res = await this.markAllAsRead()
      if (res && res.success) {
        this.pushNotifications = this.pushNotifications.map(n => ({ ...n, read: true }))
        this.unreadCount = 0
      }
    },
    formatDate(dateStr) {
      const date = new Date(dateStr)
      return date.toLocaleString('it-IT', {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    getIcon(type) {
      switch (type) {
        case 'booking': return 'mdi-calendar-check'
        case 'cancellation': return 'mdi-calendar-remove'
        case 'review': return 'mdi-star-circle'
        default: return 'mdi-bell'
      }
    },
    getIconColor(type) {
      switch (type) {
        case 'booking': return 'green'
        case 'cancellation': return 'red'
        case 'review': return 'amber darken-2'
        default: return 'grey'
      }
    },
    async openModalAllNotifications() {
      this.dialog = true
      this.page = 1
      this.allNotifications = []
      this.total = 0
      await this.loadPaginatedNotifications()
    },

    async loadPaginatedNotifications() {
      if (this.loadingAll || (this.allNotifications.length >= this.total && this.total > 0)) return
      this.loadingAll = true
      const res = await this.getAllNotifications({ page: this.page, limit: this.limit })
      if (res && res.data) {
        this.allNotifications.push(...res.data)
        this.total = res.total
        this.page++
      }
      this.loadingAll = false
    },

    handleScroll(e) {
      const el = e.target
      const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 10
      if (atBottom) this.loadPaginatedNotifications()
    },
  }
}
</script>


<style scoped>
.notification-item {
  cursor: pointer;
  transition: background 0.2s;
  padding-top: 2px;
  padding-bottom: 2px;
}
.notification-item.unread {
  background-color: #e3f2fd;
}
.notification-item:hover {
  background: #f5f5f5;
}
.text-wrap {
  white-space: normal !important;
  word-break: break-word;
}

.notification-card {
  max-height: 500px;
  overflow-y: auto;
  padding-right: 4px; /* spazio per scrollbar */
  background-color: #f9f9f9; /* sfondo chiaro per visibilità */
  border-radius: 4px;
}

.notification-scroll {
  max-height: 70vh;
  overflow-y: auto;
  padding-left: 5px !important;
  padding-right: 5px !important;;
}

.text-wrap {
  white-space: normal !important;
  word-break: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
}

.notifications-menu {
  width: 500px !important;
  max-width: 90vw !important; /* fallback mobile */
  right: 8px !important;
  left: auto !important;
  transform-origin: top right !important;
}

.notifications-card {
  width: 100%;
}

@media (max-width: 600px) {
  .v-list-item {
    flex-wrap: wrap;
    align-items: flex-start !important;
  }

  .v-list-item-avatar {
    margin-right: 12px !important;
  }

  .v-list-item-content {
    flex: 1 1 100%;
    max-width: 100%;
  }

  .notifications-menu {
  }
}


</style>

